import React from 'react'

import * as c from '../../../common'

import Button from '@mui/material/Button'
import moment from 'moment'

import * as gs from '../../../app/gStyles'
import ContractLogo, { ContractLogoProps } from '../ContractLogo'
import { nirvanaContract } from '../../constants'
import ContractDetailRow from '../ContractDetailRow'
import ReportPages, { horizontalPad } from '../ReportPages'

//@ts-ignore
import styles from './NirvanaContractView.module.css'

export type NirvanaContractProps = c.r<{
  /**
   * report_nirvana_finance
   */
  amountFinance: string
  amountFinanceOnChange: React.EventHandler<React.ChangeEvent<HTMLInputElement>>
  /**
   * report_nirvana_remaining
   */
  amountRemaining: string
  amountRemainingOnChange: React.EventHandler<
    React.ChangeEvent<HTMLInputElement>
  >
  /**
   * report_nirvana_upfront
   */
  amountUpfront: string
  amountUpfrontOnChange: React.EventHandler<React.ChangeEvent<HTMLInputElement>>

  contractCompanyFull: c.ContractCompany
  contractCompanyOnChange?: ContractLogoProps['onChangeContractCompany']
  contractCompanyOpts: ContractLogoProps['options']

  customerAddress: string
  customerEmail: string
  customerName: string
  customerPhone: string
  customerPhoneAlt: string
  customerSignature: string
  customerSignatureDate: number | null | undefined

  isPDF: boolean

  repName: string
  repSignature: string
  repSignatureDate: number | undefined
  rows: c.IContractDetailRow[]
  state: string

  toggleCompanySignatureModal(): void
  toggleSignatureModal(): void
  totalCostCustomer: number
}>

export default React.memo<NirvanaContractProps>(function NirvanaContract({
  amountFinance,
  amountFinanceOnChange,
  amountUpfront,
  amountUpfrontOnChange,
  amountRemaining,
  amountRemainingOnChange,
  contractCompanyFull,
  contractCompanyOnChange,
  contractCompanyOpts,
  customerAddress,
  customerEmail,
  customerName,
  customerPhone,
  customerPhoneAlt,
  customerSignature,
  customerSignatureDate,
  isPDF,
  repName,
  repSignature,
  repSignatureDate,
  rows: _rows,
  state,
  toggleCompanySignatureModal,
  toggleSignatureModal,

  totalCostCustomer,
}) {
  //#region styling
  //#endregion
  //#region global
  const strings = React.useMemo(
    () =>
      nirvanaContract(
        contractCompanyFull.longName,
        contractCompanyFull.shortName,
      ),
    [contractCompanyFull.longName, contractCompanyFull.shortName],
  )

  //#endregion
  //#region local
  //#endregion

  const buttonSignatureStyle = React.useMemo(
    () => ({
      backgroundColor: c.companyColors[state],
      '&:hover': { backgroundColor: c.companyColors[state] },
      width: 256,
    }),
    [state],
  )

  const lastRow = _rows[_rows.length - 1]
  const rows = _rows.slice(0, -1)

  return (
    <ReportPages companyBorder hPad isPDF={isPDF} noAlignCenter state={state}>
      <div style={sx.logo}>
        <ContractLogo
          contractCompanyFull={contractCompanyFull}
          isPDF={isPDF}
          onChangeContractCompany={contractCompanyOnChange}
          options={contractCompanyOpts}
          size="l"
        />
      </div>

      {gapBig}

      <div>
        <p className={styles['heading']}>{contractCompanyFull.longName}</p>

        {gapBig}

        <p style={sx.companyInfo}>{contractCompanyFull.address1}</p>
        <p style={sx.companyInfo}>{contractCompanyFull.email}</p>
        <p style={sx.companyInfo}>{contractCompanyFull.phoneNumber}</p>
      </div>

      {gapMedium}

      <div style={gs.rowSpaceBetween}>
        <p style={gs.margin0}>
          Date: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <span className={styles['underlined']}>
            {customerSignature && typeof customerSignatureDate === 'number'
              ? moment(customerSignatureDate).format(c.readableDateFormat)
              : moment().format(c.readableDateFormat)}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </p>
        <p style={gs.margin0}>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Property Owner(s):
          <span className={styles['underlined']}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            {customerName}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </p>
      </div>

      {gapSmall}

      <div style={gs.rowSpaceBetween}>
        <p style={gs.margin0}>
          <span>Phone: </span>
          <span className={styles['underlined']}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            {customerPhone}
            {customerPhoneAlt ? ` / ${customerPhoneAlt}` : ''}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </p>

        <p style={gs.margin0}>
          <span>Email: </span>
          <span className={styles['underlined']}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            {customerEmail}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </p>
      </div>

      {gapSmall}

      <p style={gs.margin0}>
        Property Address:
        <span className={styles['underlined']}>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          {customerAddress}
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span>
      </p>

      {gapBig}

      <p style={sx.node}>
        {strings['aa']}{' '}
        <span className={styles['underlined']}>
          &nbsp;
          {`$ ${totalCostCustomer}`}
          &nbsp;
        </span>
        {strings['ab']}
      </p>

      {gapBig}

      <p className={styles['subheading']}>{strings['bTitle']}</p>

      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          fontFamily: 'Game',
          margin: 0,
          width: '100%',
        }}
      >
        <p
          style={{
            fontFamily: 'Game',
            fontWeight: 'bold',
            textAlign: 'center',
            width: '15%',
          }}
        >
          Quantity
        </p>

        <p style={{ fontFamily: 'Game', fontWeight: 'bold', width: '70%' }}>
          Description
        </p>

        <p
          style={{
            fontFamily: 'Game',
            fontWeight: 'bold',
            textAlign: 'end',
            width: '15%',
          }}
        >
          Total Cost
        </p>
      </div>

      {rows.map((row) => (
        <ContractDetailRow {...row} key={row.description} />
      ))}

      <div style={gs.flowRootWidth100}>
        {lastRow && <ContractDetailRow {...lastRow} />}

        <p style={sx.grandTotal}>
          <span style={{ fontFamily: 'Game', fontWeight: 'bold' }}>
            GRAND TOTAL: {c.blankChar(12)}
            {Intl.NumberFormat('en-US', {
              currency: 'USD',
              maximumFractionDigits: 2,
              minimumFractionDigits: 2,
              style: 'currency',
            }).format(totalCostCustomer)}
          </span>
        </p>
      </div>

      {gapBig}

      {/* This flow-root ensures cTitle doesn't get spilt off its content and
      also ensures a page break after the scope of work unless the scope of work
      is really small, overall making it more presentable */}
      <div style={gs.flowRootWidth100}>
        <p className={styles['subheading']}>{strings['cTitle']}</p>

        {gapSmall}

        {/* Have total amt floating around somewhere in here */}
        <p style={sx.node}>
          <span>{strings['ca']} </span>

          {isPDF ? (
            <span className={styles['underlined']}>
              {amountFinance
                ? Intl.NumberFormat('en-US', {
                    currency: 'USD',
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2,
                    style: 'currency',
                  }).format(c.parseFloating(amountFinance))
                : '\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0'}
            </span>
          ) : (
            <input
              className={styles['input-inline']}
              onChange={amountFinanceOnChange}
              title={`Total cost (pre-financing): ${totalCostCustomer}`}
              value={amountFinance}
            />
          )}

          <span>{strings['cb']}</span>

          {isPDF ? (
            <span className={styles['underlined']}>
              {amountUpfront
                ? Intl.NumberFormat('en-US', {
                    currency: 'USD',
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2,
                    style: 'currency',
                  }).format(c.parseFloating(amountUpfront))
                : '\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0'}
            </span>
          ) : (
            <input
              className={styles['input-inline']}
              onChange={amountUpfrontOnChange}
              title={`Total cost (pre-financing): ${totalCostCustomer}`}
              value={amountUpfront}
            />
          )}

          <span>{strings['cc']}</span>

          {isPDF ? (
            <span className={styles['underlined']}>
              {amountRemaining
                ? Intl.NumberFormat('en-US', {
                    currency: 'USD',
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2,
                    style: 'currency',
                  }).format(c.parseFloating(amountRemaining))
                : '\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0'}
            </span>
          ) : (
            <input
              className={styles['input-inline']}
              onChange={amountRemainingOnChange}
              title={`Total cost (pre-financing): ${totalCostCustomer}`}
              value={amountRemaining}
            />
          )}

          <span>{strings['cd']}</span>
        </p>

        {gapBig}

        <p className={styles['subheading']}>{strings['dTitle']}</p>

        {gapSmall}

        <p style={sx.node}>{strings['da']}</p>

        {gapBig}
      </div>
      {/* end flow-root */}

      <p style={sx.node}>{strings['ea']}</p>

      {gapBig}

      <p style={sx.node}>{strings['fa']}</p>

      {gapBig}

      <p style={sx.node}>{strings['ga']}</p>

      {gapBig}

      <p style={sx.node}>{strings['ha']}</p>

      {gapBig}

      <p style={sx.node}>{strings['ia']}</p>

      {gapBig}

      <p style={sx.node}>{strings['ja']}</p>

      {gapBig}

      <p style={sx.node}>{strings['ka']}</p>

      {gapBig}

      <p style={sx.node}>{strings['la']}</p>

      {gapBig}

      {/* This flow-root ensures signatures aren't awkwardly by themselves on
        a lone page, tying them together with the last paragraph of 
        conditions */}
      <div style={gs.flowRootWidth100}>
        <p style={sx.node}>{strings['ma']}</p>

        {gapBig}

        <div className={styles['signatures']}>
          <div className={styles['signature-container']}>
            <div>
              <p className={styles['label-signature']}>Property owner:</p>

              <span>{customerName}</span>
            </div>

            {gs.rowGap24}

            {customerSignature && (
              <>
                <img
                  alt=""
                  className={styles['signature-img']}
                  src={customerSignature}
                  width={200}
                />
                <p>
                  {typeof customerSignatureDate === 'number'
                    ? moment(customerSignatureDate).format(
                        'YYYY/MM/DD - hh:mma',
                      )
                    : null}
                </p>
              </>
            )}

            <p>Address: {customerAddress}</p>

            {gs.rowGap24}

            {isPDF || customerSignature ? (
              <div />
            ) : (
              <Button
                onClick={toggleSignatureModal}
                sx={buttonSignatureStyle}
                variant="contained"
              >
                Client Signature
              </Button>
            )}
          </div>

          <div className={styles['signature-container']}>
            <div>
              <p className={styles['label-signature']}>Contractor:</p>
              <span>{repName}</span>
            </div>

            {repSignature && (
              <>
                <img
                  alt=""
                  className={styles['signature-img']}
                  src={repSignature}
                  width={200}
                />
                <p>
                  {typeof repSignatureDate === 'number'
                    ? moment(repSignatureDate).format('YYYY/MM/DD - hh:mma')
                    : null}
                </p>
              </>
            )}

            {gs.rowGap24}

            <p className={styles['label-signature']}>
              Authorized Representative of
            </p>
            <p className={styles['label-signature']}>
              {contractCompanyFull.longName}
            </p>

            {gs.rowGap24}

            {isPDF || repSignature ? (
              <div />
            ) : (
              <Button
                onClick={toggleCompanySignatureModal}
                sx={buttonSignatureStyle}
                variant="contained"
              >
                Authorized Signature
              </Button>
            )}
          </div>
        </div>
      </div>
    </ReportPages>
  )
})

const gapBig = gs.rowGap32
const gapMedium = gs.rowGap28
const gapSmall = gs.rowGap16

const sx = {
  companyInfo: { margin: 0, textAlign: 'center' as const },
  grandTotal: {
    fontFamily: 'Game',
    fontSize: 18,
    margin: 0,
    textAlign: 'end' as const,
    width: '100%',
  },
  logo: { left: horizontalPad, position: 'absolute' as const, top: '96px' },
  node: { margin: 0, textAlign: 'justify' as const },
}
